<script>
    import * as VueGoogleMaps from 'vue2-google-maps';
    export default {
        components: {
            'google-map': VueGoogleMaps.Map,
            'google-marker': VueGoogleMaps.Marker,
        },
        mounted() {
            this.$refs.mapRef.$mapPromise.then((map) => {
                map.set('navigationControl', false);
                map.set('mapTypeControl', false);
                map.set('fullscreenControl', false);
                map.set('rotateControl', false);
            })
        },

    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/reservation/ReservationGoogleMap.vue